import React from 'react';

import commonUtil from '../../utils/commonUtil';

export default class Pagination extends React.Component {

  constructor(props) {
    super(props);
    this.pages = [];
    this.firstDisabled = false;
    this.lastDisabled = false;

    this.totalNoOfRecords = this.props.paginationInfo.totalNoOfRecords
      ? +this.props.paginationInfo.totalNoOfRecords
      : 1;

    this.recordsPerPage = this.props.paginationInfo.recordsPerPage
      ? +this.props.paginationInfo.recordsPerPage
      : 10;

    this.visiblePages = this.props.visiblePages
      ? +this.props.visiblePages
      : 5;

    this.state = {
      currentPage: this.props.paginationInfo.currentPage
        ? +this.props.paginationInfo.currentPage
        : 1,
    };
  }

  UNSAFE_componentWillMount() {
    this.gotoPage(this.state.currentPage);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.paginationInfo) {
      this.totalNoOfRecords = nextProps.paginationInfo.totalNoOfRecords
        ? +nextProps.paginationInfo.totalNoOfRecords
        : 1;

      this.recordsPerPage = nextProps.paginationInfo.recordsPerPage
        ? +nextProps.paginationInfo.recordsPerPage
        : 10;

      this.visiblePages = nextProps.paginationInfo.visiblePages
        ? +nextProps.paginationInfo.visiblePages
        : 5;

      if (this.state.currentPage !== nextProps.paginationInfo.currentPage) {
        const totalPages = Math.ceil(this.totalNoOfRecords / this.recordsPerPage);
        this.pages = this.getPages(this.state.currentPage, this.visiblePages, totalPages);
        this.setState({ currentPage: +nextProps.paginationInfo.currentPage });
      }
    }
  }

  getPages = (currentPage, visiblePages, totalPages) => {
    const pages = [];
    const half = Math.floor(visiblePages / 2);
    let start = currentPage - (half + (1 - (visiblePages % 2)));
    let end = currentPage + half;
    // handle boundary case
    if (start <= 0) {
      start = 1;
      end = visiblePages;
    }
    if (end > totalPages) {
      start = ((totalPages - visiblePages) + 1) > 1
        ? ((totalPages - visiblePages) + 1)
        : 1;
      end = totalPages;
    }

    let itPage = start;
    while (itPage <= end) {
      pages.push(itPage);
      itPage += 1;
    }
    return pages;
  }

  gotoPage = (val) => {
    this.firstDisabled = false;
    this.lastDisabled = false;
    const totalPages = Math.ceil(this.totalNoOfRecords / this.recordsPerPage);
    let currpage = 1;

    switch (val) {
      case 'first':
        currpage = 1;
        break;

      case 'previous':
        currpage = ((this.state.currentPage - 1) < 1) ? 1 : this.state.currentPage - 1;
        break;

      case 'next':
        currpage = (this.state.currentPage + 1) >= totalPages ? totalPages : this.state.currentPage + 1;
        break;

      case 'last':
        currpage = totalPages;
        break;

      default:
        currpage = +val;
        break;
    }

    // For enable/disable buttons on first/last record respectively
    if (currpage === 1) {
      this.firstDisabled = true;
    } else if (currpage === totalPages) {
      this.lastDisabled = true;
    }

    const pages = this.getPages(currpage, this.visiblePages, totalPages);

    this.setState({ currentPage: currpage });
    this.pages = pages;

    if (this.state.currentPage !== currpage && this.props.onPageChange) {
      this.props.onPageChange(currpage);
    }

    try {
      const woy = window.pageYOffset;
      if (window.scrollY && woy >= 500) {
        window.scroll(0, 0);  // reset the scroll position to the top left of the document.
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('fail', error.message); // console required
    }
  }

  render() {
    const numPage = (data, index) => (
      <li
        className={(this.state.currentPage === data) ? 'active' : ''}
        onClick={() => {
          this.gotoPage(data);
        }}
        key={index}
      >
        <a
          className={`numPage ${this.props.giftSummary ? 'gift-summary-page' : ''}`}
          href="javascript:void(0)"
        >
          {data}
        </a>
      </li>
    );

    return (
      <div className="controlPage">
        <ul className="customPagination">
          <li
            className={`${this.firstDisabled ? 'removeArrow' : ''}`}
            disabled={this.firstDisabled ? 'disabled' : ''}
            style={{ opacity: this.firstDisabled ? 0.4 : 1 }}
            onClick={() => { this.gotoPage('first'); }}
          >
            <a className="start" href="javascript:void(0)">
              <img src={`${commonUtil.getAssetURL()}/images/double_arrow_right.svg`} alt="" className='transform_oneEight double_arrow_left'/>
              {this.props.firstLabel
                ? <span>&nbsp{this.props.firstLabel}</span>
                : null}
            </a>
          </li>

          <li
            className={`${this.firstDisabled ? 'removeArrow' : ''}`}
            disabled={this.firstDisabled ? 'disabled' : ''}
            style={{ opacity: this.firstDisabled ? 0.4 : 1 }}
            onClick={() => { this.gotoPage('previous'); }}
          >
            <a className="back" href="javascript:void(0)">
              <img src={`${commonUtil.getAssetURL()}/images/chevron_right.svg`} alt="" className='transform_oneEight single_arrow_left'/>
              {this.props.prevLabel
                ? <span>&nbsp{this.props.prevLabel}</span>
                : null}
            </a>
          </li>

          {this.pages.map(numPage)}

          <li
            className={`${this.lastDisabled ? 'removeArrow' : ''}`}
            disabled={this.lastDisabled ? 'disabled' : ''}
            style={{ opacity: this.lastDisabled ? 0.4 : 1 }}
            onClick={() => { this.gotoPage('next'); }}
          >
            <a className="start" href="javascript:void(0)">
              {this.props.nextLabel ? <span>{this.props.nextLabel}&nbsp</span> : null}
              <img src={`${commonUtil.getAssetURL()}/images/chevron_right.svg`} alt="" className='single_arrow_right' />
            </a>
          </li>

          <li
            className={`${this.lastDisabled ? 'removeArrow' : ''}`}
            disabled={this.lastDisabled ? 'disabled' : ''}
            style={{ opacity: this.lastDisabled ? 0.4 : 1 }}
            onClick={() => { this.gotoPage('last'); }}
          >
            <a className="end" href="javascript:void(0)">
              {this.props.lastLabel ? <span>{this.props.lastLabel}&nbsp</span> : null}
              <img src={`${commonUtil.getAssetURL()}/images/double_arrow_right.svg`} alt="" className='double_arrow_right' />
            </a>
          </li>
        </ul>
      </div>
    );
  }
}
